import { MAGIC_NUMBER } from "../../constants/magicNumbers";

export const HOVERED_LISTING = "HOVERED_LISTING";
export const SEARCH_COMPLETE = "SEARCH_COMPLETE";
export const SEARCH_STARTED = "SEARCH_STARTED";
export const SHOW_MAP = "SHOW_MAP";
export const RESET_FILTERS = "RESET_FILTERS";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const POPULATE_RESULTS = "POPULATE_RESULTS";
export const SEARCH_SET_SORT = "SEARCH_SET_SORT";

export const FilterAmenity_ExtendedStay = "Extended Stay";
export const FilterAmenity_WeekendStay = "Weekend Stay";

export const FilterAmenities = [
  FilterAmenity_ExtendedStay, FilterAmenity_WeekendStay,
  "Air Conditioning*", "Bedding/Linens", "Cable TV*", "Coffee Maker", "Deck/Patio", "Dishes/Utensils",
  "Dishwasher", "DVD Player", "Fitness Room/Gym", "Game Room", "Garden/Backyard", "Grill", "Hairdryer",
  "Heating", "Hot Tub", "Indoor Fireplace", "Iron/Ironing Board", "Kitchen", "Microwave", "Paper Towels/Toilet Paper/Soap",
  "Off Street Parking*", "Pool", "Pool Table/Foosball Table", "Refrigerator", "Smart TV", "Smoke Detector", "Stove/Oven",
  "Street Parking", "Towels", "TV", "Washer/Dryer", "Wheelchair Accessible*", "WiFi*"
]

export const initialFilters = {
  geometry: {
    lng: undefined,
    lat: undefined
  },
  price: {
    min: MAGIC_NUMBER.MIN_PRICE,
    max: MAGIC_NUMBER.MAX_PRICE
  },
  dates: {
    from: undefined,
    to: undefined
  },
  guests: 1,
  bedrooms: 1,
  rating: 0,
  typeOfHome: [],
  amenities: [],
  petsAllowed: false,
  smokingAllowed: false,
  attractions: [],
  radius: 50
}
